import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, Modal, Form, Input, Select, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getFactoryList, saveFactory } from '../../api/config';
import { hasPerm } from '../../hooks/usePermission';

const FactoryManage = () => {
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [editing, setEditing] = useState(null);
    const [form] = Form.useForm();

    const fetchList = async () => {
        setLoading(true);
        try {
            const res = await getFactoryList();
            if (res.code === 0) {
                setDataSource(res.data.list);
            } else {
                message.error(res.message || '获取列表失败');
            }
        } catch (error) {
            console.error('Fetch factory list failed:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const openEdit = (record) => {
        setEditing(record);
        setModalOpen(true);
        form.setFieldsValue(record);
    };

    const openAdd = () => {
        setEditing(null);
        setModalOpen(true);
        form.resetFields();
    };

    const handleSave = async () => {
        const values = await form.validateFields();
        const res = await saveFactory(values);
        if (res.code === 0) {
            message.success('保存成功');
            setModalOpen(false);
            fetchList();
        } else {
            message.error(res.message || '保存失败');
        }
    };

    const columns = [
        { title: '工厂名称', dataIndex: 'name', key: 'name', width: 140 },
        { title: '工厂编码', dataIndex: 'code', key: 'code', width: 120 },
        { title: '联系人', dataIndex: 'contact', key: 'contact', width: 120 },
        { title: '联系电话', dataIndex: 'phone', key: 'phone', width: 160 },
        {
            title: '状态', dataIndex: 'status', key: 'status', width: 90,
            render: (v) => <Tag color={v === '启用' ? 'success' : 'default'}>{v}</Tag>,
        },
        {
            title: '操作', key: 'action', width: 160,
            onHeaderCell: () => ({ style: { textAlign: 'center' } }),
            render: (_, record) => (
                <Space>
                    {hasPerm('config:factory:edit') && (
                        <Button type="link" onClick={() => openEdit(record)}>编辑</Button>
                    )}
                    {hasPerm('config:factory:batch') && (
                        <Button type="link" onClick={() => message.info(`${record.name} 串码分批`)}>串码分批</Button>
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: '16px' }}>
            <div style={{ marginBottom: 16 }}>
                {hasPerm('config:factory:add') && (
                    <Button type="primary" icon={<PlusOutlined />} onClick={openAdd}>新增工厂</Button>
                )}
            </div>

            <Table rowKey="id" columns={columns} dataSource={dataSource} loading={loading} pagination={false} />

            <Modal
                title={editing ? '编辑工厂' : '新增工厂'}
                open={modalOpen}
                onOk={handleSave}
                onCancel={() => setModalOpen(false)}
                okText="保存"
                cancelText="取消"
                centered
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="name" label="工厂名称" rules={[{ required: true, message: '请输入工厂名称' }]}>
                        <Input placeholder="如 达天 / 凯木金 / 中嘉" />
                    </Form.Item>
                    <Form.Item name="code" label="工厂编码" rules={[{ required: true, message: '请输入工厂编码' }]}>
                        <Input placeholder="如 DT" />
                    </Form.Item>
                    <Form.Item name="contact" label="联系人">
                        <Input placeholder="请输入联系人" />
                    </Form.Item>
                    <Form.Item name="phone" label="联系电话">
                        <Input placeholder="请输入联系电话" />
                    </Form.Item>
                    <Form.Item name="status" label="状态" initialValue="启用">
                        <Select options={[{ value: '启用', label: '启用' }, { value: '停用', label: '停用' }]} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default FactoryManage;
